import { render, staticRenderFns } from "./MonthlyBill.vue?vue&type=template&id=c8f4257a&scoped=true&"
import script from "./MonthlyBill.vue?vue&type=script&lang=js&"
export * from "./MonthlyBill.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyBill.vue?vue&type=style&index=0&id=c8f4257a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f4257a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
